// extracted by mini-css-extract-plugin
export var assigneeBadge = "_je-0";
export var assigneeDetails = "_je-1";
export var assigneeInfo = "_je-2";
export var dropdownContainer = "_je-4";
export var dropdownImage = "_je-5";
export var editAssigneeInfo = "_je-3";
export var editAssigneeModalContainer = "_je-6";
export var hidden = "_je-8";
export var input = "_je-7";